import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=9794cb0a&scoped=true"
import script from "./ProfileDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileDetail.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileDetail.vue?vue&type=style&index=0&id=9794cb0a&prod&lang=scss&scoped=true"
import style1 from "./ProfileDetail.vue?vue&type=style&index=1&id=9794cb0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9794cb0a",
  null
  
)

export default component.exports